import { render } from "./ReferralsView.vue?vue&type=template&id=71dd37af&scoped=true"
import script from "./ReferralsView.vue?vue&type=script&lang=js"
export * from "./ReferralsView.vue?vue&type=script&lang=js"

import "./ReferralsView.vue?vue&type=style&index=0&id=71dd37af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71dd37af"]])

export default __exports__